/**
 * Generates SHA256 hash of the given string
 * @param message - The string to hash
 * @returns Promise<string> - The SHA256 hash as a hex string
 */
const generateSHA256Hash = async (message: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return hashHex;
};

export default generateSHA256Hash;
